import { Controller } from "@hotwired/stimulus"
import { formatNumberInput, formatCurrency } from "../lib/number_format"

// Formats an amount input while typing and again when leaving the field.
//   <input data-controller="number-input"
//          data-action="input->number-input#format focusout->number-input#finish">
export default class extends Controller {
  format() {
    this.element.value = formatNumberInput(this.element.value)
  }

  finish() {
    this.element.value = formatCurrency(this.element.value)
  }
}
